/*
 * Copyright (c) 2023-2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      19 February 2024
 */

import { createBrowserRouter } from 'react-router-dom';
import Layout from '../../Layout/Layout';
import Projects from '../../Layout/Pages/Projects';
import Cosmopolitan from '../../Layout/Pages/Project/Cosmopolitan';
import Badilli from '../../Layout/Pages/Project/Badilli';
import DolceVita from '../../Layout/Pages/Project/DolceVita';
import Dome from '../../Layout/Pages/Project/Dome';
import Me from '../../Layout/Pages/Project/Me';
import Yalihan from '../../Layout/Pages/Project/Yalihan';
import AboutUs from '../../Layout/Pages/AboutUs';
import ContactUs from '../../Layout/Pages/ContactUs';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { path: '/', element: <Projects /> },
      { path: '/about-us', element: <AboutUs /> },
      { path: '/contact-us', element: <ContactUs /> },
      { path: 'project/badilli', element: <Badilli /> },
      { path: 'project/cosmopolitan', element: <Cosmopolitan /> },
      { path: 'project/dolce-vita', element: <DolceVita /> },
      { path: 'project/dome', element: <Dome /> },
      { path: 'project/me', element: <Me /> },
      { path: 'project/yalihan', element: <Yalihan /> },
    ],
  },
]);
